import { useLocation } from "react-router-dom";
import Grid from "@mui/material/Grid";
import { Typography } from "@mui/material";
import { pageRoutes } from "../constants";

// Where the link in the registration approval email lands the GGF approver
const outcomes = {
  [pageRoutes.REGISTRATION_APPROVED]: {
    title: "Registration approved 🎉",
    message:
      "We’ve emailed the broker to let them know. They can sign in once their email address is verified. You may close this window.",
  },
  [pageRoutes.REGISTRATION_ALREADY_APPROVED]: {
    title: "Already approved",
    message: "This registration has already been approved, so there’s nothing more to do. You may close this window.",
  },
  [pageRoutes.REGISTRATION_APPROVAL_FAILED]: {
    title: "We couldn’t approve this registration",
    message:
      "This approval link is invalid, or the account can no longer be approved. Please contact Financeable support if you need help.",
  },
};

export default function AcceptRequestToJoin() {
  const { pathname } = useLocation();
  const { title, message } =
    outcomes[pathname.replace(/\/$/, "")] || outcomes[pageRoutes.REGISTRATION_APPROVAL_FAILED];

  return (
    <>
      <Grid
        container
        item
        height="calc(100vh - 64px)"
        width="100%"
        justifyContent="center"
        alignItems="center"
        marginTop="-64px"
      >
        <Grid item xs={12} sm={6} textAlign="center">
          <Typography variant="h4" sx={{ fontWeight: "bold", mb: 1 }}>
            {title}
          </Typography>
          <Typography variant="body1">{message}</Typography>
        </Grid>
      </Grid>
    </>
  );
}
